"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.productionLayer = void 0;
const buildings_1 = require("../config/buildings");
exports.productionLayer = {
    name: 'production',
    tickRate: 1,
    execute(state, _tick) {
        const elec = state.layers.electricity;
        const prod = state.layers.production;
        const hasPower = elec.supply > 0;
        // Sort buildings by id for determinism
        const sorted = [...state.buildings].sort((a, b) => a.id.localeCompare(b.id));
        const buildingProgress = Object.assign({}, prod.buildingProgress);
        const buildings = sorted.map(building => {
            if (!building.isEnabled)
                return building;
            const config = buildings_1.allBuildings[building.name];
            if (!config)
                return building;
            const levelConfig = config.levels[building.level];
            if (!levelConfig)
                return building;
            // Only mining and factory produce in this layer
            if (config.type !== 'mining' && config.type !== 'factory')
                return building;
            // Check energy
            if (!hasPower)
                return building;
            // For factory: check if we have input resources
            if (config.type === 'factory') {
                const costs = levelConfig.costs;
                for (const [resource, amount] of Object.entries(costs)) {
                    if (resource === 'energy')
                        continue; // energy is pooled
                    if ((building.contains[resource] || 0) < amount) {
                        return building; // not enough input, skip
                    }
                }
            }
            // Increment progress
            const progress = (buildingProgress[building.id] || 0) + 1;
            const cycleTime = levelConfig.time;
            if (progress >= cycleTime) {
                // Production cycle complete
                buildingProgress[building.id] = 0;
                // Consume costs (non-energy resources from building.contains)
                const newContains = Object.assign({}, building.contains);
                if (config.type === 'factory') {
                    for (const [resource, amount] of Object.entries(levelConfig.costs)) {
                        if (resource === 'energy')
                            continue;
                        newContains[resource] = (newContains[resource] || 0) - amount;
                    }
                }
                // Add provides
                for (const [resource, amount] of Object.entries(levelConfig.provides)) {
                    newContains[resource] = (newContains[resource] || 0) + amount;
                }
                return Object.assign(Object.assign({}, building), { contains: newContains });
            }
            else {
                buildingProgress[building.id] = progress;
                return building;
            }
        });
        return Object.assign(Object.assign({}, state), { buildings, layers: Object.assign(Object.assign({}, state.layers), { production: Object.assign(Object.assign({}, prod), { buildingProgress }) }) });
    },
};



//////////////////
// WEBPACK FOOTER
// ../engine/dist/layers/production.js
// module id = 6AdN
// module chunks = 0